import { isUndefined } from "lodash";
import { alertType, appToast } from "utils/toaster/toaster.util";

export const locationKeys = {
  href: "href",
  origin: "origin",
  pathname: "pathname",
  port: "port",
  protocol: "protocol",
  hostname: "hostname",
};

export const getWindowLocationValues = (key = locationKeys.hostname) => {
  if (!isUndefined(window)) {
    return window?.location[key];
  }
  return null;
};

export const goToUrl = (url) => {
  try {
    window.location.href = url;
  } catch (error) {
    const errMsg = `Error while redirecting to URL:, ${error}`;
    appToast(alertType.alert_error, errMsg);
    console.error(errMsg);

    throw error;
  }
};
